import React, { Component } from 'react';
import { connect } from 'react-redux';
import { loadMakeupSummaryByChildAndTerm } from './actions';
import { getDefaultActiveTerm } from '../common/actions';
import { getChild } from '../reducer';
import CollapsablePanel from '../../common/components/CollapsablePanel';
import ui from '../../common/services/ui';
import utils from '../../common/services/utils';
import EntitiesList from '../../common/components/EntitiesList';
import { withTranslation } from 'react-i18next';
import moment from 'moment';
import { Row, Col, Glyphicon } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import FontAwesome from 'react-fontawesome';

class MakeupSummary extends Component {
	constructor(props) {
		super(props);
	}

	componentDidMount() {
		if (this.props.activeTerm) {
			this.loadMakeupSummaryByTerm(this.props.activeTerm);
		}
	}

	componentWillReceiveProps(nextProps) {
		if (!this.props.activeTerm && nextProps.activeTerm) {
			this.loadMakeupSummaryByTerm(nextProps.activeTerm);
		}
	}

	columns(t) {
		const columns = [
			{
				accessor: 'start',
				cell: (start, row) => (this.props.enableUserTimeZone ? utils.convertToUserTime(moment(start), row.center) : moment(start)).format('L LT')
			},
			{
				accessor: 'canceled',
				cell: (canceled, row) => canceled && row.canceledByAdmin ? t('MakeupSummary_CanceledByAdminOn', { cancellationDate: ui.formatDateTime(row.cancellationDate) }) :
					(canceled && !row.canceledByAdmin ? t('MakeupSummary_CanceledByParentOn', { cancellationDate: ui.formatDateTime(row.cancellationDate) }) : '')
			},
			{
				accessor: 'isAttended',
				cell: (isAttended) => isAttended ? t('MakeupSummary_Attended') : ''
			}
		];

		return columns;
	}

	loadMakeupSummaryByTerm(term) {
		this.props.loadMakeupSummaryByChildAndTerm(this.props.childId, term.id, term.active);	// force reload for current active term only (if parent cancels a lesson)
	}

	renderTermLessons(termId) {
		const { makeupSummary, makeupSummaryByChildAndTermFilter, childId, centers, t } = this.props;

		const makeupSummaryFilter = makeupSummaryByChildAndTermFilter[`${childId}-${termId}`] || { ids: [] };
		const termLessons = makeupSummaryFilter.ids.map(id => makeupSummary[id])
		const groupedByCenter = termLessons.length > 0 && utils.groupBy(termLessons, 'centerId');
		const childCenters = Object.keys(groupedByCenter).map(key => centers[key])
		termLessons.forEach(lesson => {
			lesson.center = centers[lesson.centerId];
		});
		const allowedMakeup = termLessons.filter(l => l.allowedMakeup).sort((a, b) => moment(a.start) - moment(b.start));
		const makeups = termLessons.filter(l => l.lessonType === 3).sort((a, b) => moment(a.start) - moment(b.start));

		return childCenters.map(c => c &&
			<div key={c.id}>
				<h5><Glyphicon glyph='map-marker' /> {c.name}</h5>
				<Row>
					<Col sm={6}>
						<div>{t('FO_MakeupSummary_AllowedMakeup')}</div>
						<EntitiesList columns={this.columns(t)} data={allowedMakeup.filter(l => l.centerId === (c.id))} />
					</Col>
					<Col sm={6}>
						<div>{t('FO_MakeupSummary_Makeups')}</div>
						<EntitiesList columns={this.columns(t)} data={makeups.filter(l => l.centerId === (c.id))} />
					</Col>
				</Row>
			</div>
		);
	}

	render() {
		const { terms, activeTerm, t } = this.props;

		let makeupSummary = <p style={{ padding: '10px' }}>{t('FO_Common_NoResults')}</p>;
		if (terms && terms.length > 0) {
			makeupSummary = Object.values(terms).map(term => 
				<CollapsablePanel key={term.id} title={`${t('FO_Dashboard_LabelTerm')} ${term.name}`} collapsed={activeTerm && term.id != activeTerm.id} onExpand={() => this.loadMakeupSummaryByTerm(term)}>
					{this.renderTermLessons(term.id)}
				</CollapsablePanel>);
		}

		return <div>
			<h3>{t('FO_Child_MakeupSummary')}</h3>
			{makeupSummary}
			<Row>
				<Col sm={12}>
					<Link to='/children' className='btn btn-back btn-block-xxs'><FontAwesome name='arrow-circle-left' /> {t('Common_BackToList')}</Link>
				</Col>
			</Row>
		</div>;
	}
}

const mapStateToProps = (state, ownProps) => {
	const childId = Number(ownProps.match.params.id);

	const {
		parent,
		entities: { makeupSummary, terms, centers },
		filters: { makeupSummaryByChildAndTerm },
		configuration: { franchisor }
	} = state;

	const child = getChild(parent, childId);
	const classes = child && child.attendedClasses;
	const groupedByTerm = classes && classes.length > 0 && utils.groupBy(classes, 'termId');
	const childTerms = groupedByTerm && Object.keys(groupedByTerm).filter(key => terms[key]).map(key => terms[key]).sort((a, b) => moment(b.startDate) - moment(a.startDate));
	const activeTerm = childTerms && childTerms.length > 0 && (getDefaultActiveTerm(childTerms) || childTerms[0]);	// current term or the last term the child is enrolled into (if not enrolled in the current)

	return {
		centers,
		makeupSummary,
		childId,
		child,
		terms: childTerms,
		activeTerm,
		makeupSummaryByChildAndTermFilter: makeupSummaryByChildAndTerm,
		enableUserTimeZone: franchisor && franchisor.enableUserTimeZone
	};
};

export default connect(mapStateToProps, {
	loadMakeupSummaryByChildAndTerm
})(withTranslation()(MakeupSummary));